<template>
  <div class="group relative" v-click-outside="hide">
    <div class="cursor-pointer" @click.capture="click">
      <slot name="button">SOME BUTTON</slot>
    </div>

    <div
      class="absolute z-20 group-hover:block bg-white rounded overflow-hidden shadow-md text-black"
      :class="[dropClass, isHidden ? 'hidden' : '']"
      @click="hide"
    >
      <slot />
    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";

const isHover = (e) => e.parentElement.querySelector(":hover") === e;

export default {
  props: {
    dropClass: {
      type: String,
    },
  },
  data() {
    return { isHidden: true, isTouch: null };
  },
  methods: {
    click(event) {
      if (this.isTouch === null) {
        this.isTouch = !isHover(event.target);
      }
      if (this.isTouch) {
        this.isHidden = !this.isHidden;
        event.stopPropagation();
        event.preventDefault();
      }
    },
    hide() {
      this.isHidden = true;
    },
  },
  directives: {
    ClickOutside,
  },
};
</script>
